import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Merchant } from "@/types/merchant";
import {
  createFileRoute,
  Link,
  Navigate,
  Outlet,
  redirect,
  useLocation,
} from "@tanstack/react-router";
import { useSelectedApplication } from "@/hooks/use-selected-application";

/**
 * Needs hasVirtualAccountsEnabled to be true
 */
export function shouldShowBalances(
  selectedApplication: Merchant["applications"][number],
) {
  return selectedApplication.hasVirtualAccountsEnabled;
}

export const Route = createFileRoute("/(app)/_main-layout/_balances/balances")({
  component: () => <BalancesLayoutComponent />,
  beforeLoad: ({ location }) => {
    if (location.pathname === "/balances") {
      throw redirect({ to: "/balances/overview", search: (s) => s });
    }
  },
});

const BalancesLayoutComponent = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const selectedApplication = useSelectedApplication();

  if (!shouldShowBalances(selectedApplication)) {
    return <Navigate to="/payments/payin" />;
  }

  return (
    <div>
      <Tabs value={pathname.split("/").at(-1)}>
        <TabsList>
          <Link to={`/balances/overview`} search>
            <TabsTrigger value="overview">Overview</TabsTrigger>
          </Link>
        </TabsList>
      </Tabs>
      <div className="mt-2">
        <Outlet />
      </div>
    </div>
  );
};
